import { render, staticRenderFns } from "./dispute_detail.vue?vue&type=template&id=b82b11d0&scoped=true"
import script from "./dispute_detail.vue?vue&type=script&lang=js"
export * from "./dispute_detail.vue?vue&type=script&lang=js"
import style0 from "./dispute_detail.vue?vue&type=style&index=0&id=b82b11d0&prod&lang=stylus&scoped=true"
import style1 from "./dispute_detail.vue?vue&type=style&index=1&id=b82b11d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82b11d0",
  null
  
)

export default component.exports